// removed by extract-text-webpack-plugin
module.exports = {"Footer":"_3qXVPh1biXkI4T-r9d5IT_","Container":"_2Y_ZDAZ403pCUV7LcqYWT2","Copy":"_23c_yYpTTPSA4xe9LpqJ1Q"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Footer/styles.module.css
// module id = 552
// module chunks = 0